// import * as amplitude from "@amplitude/analytics-browser"

export const trackEvent = (event: string, properties?: any) => {
  // amplitude.track(event, properties)
}

export const trackUser = (properties: any) => {
  // const identifyUser = new amplitude.Identify()
  // for (const prop in properties) {
  //   identifyUser.setOnce(prop, properties[prop])
  // }
  // amplitude.identify(identifyUser)
}

export const trackUserEvent = (
  event: string,
  userProperties: any,
  eventProperties?: any
) => {
  trackUser(userProperties)
  trackEvent(event, eventProperties)
}
